import type { PresetOption } from '@modules/global-style';
import { _defaultFonts, _oldFont } from './_fontDefault';

const mapScaleSize: any = {
  'heading-1': 3,
  'heading-2': 2,
  'heading-3': 1,
  'heading-4': 0,
  'heading-5': -1,
  'heading-6': -2,
  'paragraph-1': 0,
  'paragraph-2': -1,
  'paragraph-3': -2,
  'paragraph-4': -3,
};

const rem = 'rem';
const custom = 'custom';
const mobileRate = 80;
const fontSizeDefault = 1;

const sizeScale = (key: string) => {
  return key != undefined ? mapScaleSize[key] : '';
};

const scaleFontSizeDesktop = (scale: string, key: string) => {
  return Math.pow(Number(scale), Number(sizeScale(key))).toFixed(2);
};

const scaleFontSizeMobile = (scale: string, key: string) => {
  return ((Math.pow(Number(scale), Number(sizeScale(key))) * mobileRate) / 100).toFixed(2);
};

export const generateFontSizeWithTypeScale = (presets: PresetOption[], scale: string): void[] => {
  if (!scale || scale === custom) return [];
  if (!presets) return [];
  return presets.map((preset: any) => {
    if (mapScaleSize[preset.key] === 0) {
      preset.value.screens.lg.fontSize = preset.value.screens.md.fontSize = fontSizeDefault + rem;
      preset.value.screens.sm.fontSize = preset.value.screens.xs.fontSize = (fontSizeDefault * mobileRate) / 100 + rem;
    } else {
      preset.value.screens.lg.fontSize = preset.value.screens.md.fontSize =
        scaleFontSizeDesktop(scale, preset.key) + rem;
      preset.value.screens.sm.fontSize = preset.value.screens.xs.fontSize =
        scaleFontSizeMobile(scale, preset.key) + rem;
    }
    return preset;
  });
};

export const addFontLink2Head = (font: string) => {
  const $head = jQuery('head');
  let count = 0;
  let fontFamily = font;
  if (font) {
    if (font.toLowerCase() != 'inherit' && font.toLowerCase() != 'default') {
      let i;
      const fontName = font.indexOf(':') >= 0 ? font.split(':')[0] : font;
      const styleName = fontName.replaceAll('+', ' ');
      const lengthFontDefault = _defaultFonts.length;
      for (i = 0; i < lengthFontDefault; i++) {
        if (styleName == _defaultFonts[i].styleName) {
          fontFamily = _defaultFonts[i].googleName;
          count++;
        }
      }
      if (count == 0) {
        for (i = 0; i < _oldFont.length; i++) {
          if (font == _oldFont[i]) {
            count++;
          }
        }
      }
    }

    if (count > 0) {
      const link = `//fonts.googleapis.com/css?family=${fontFamily}`;
      if ($head.find(`link[data-fonts="' ${fontFamily} '"]`).length == 0) {
        $head.append(
          `<link class="gf_fonts" data-fonts="${fontFamily}" href="${link}" rel="stylesheet" type="text/css" />`,
        );
      }
    }
  }
  return font;
};
